import { useEffect, useState } from "react";
import apiService from "Services/apiService";
import TableRender from "components/common/TableRender/TableRender"
import { SkeTable } from "components/common/Skeleton/SkeTable";
import Search from "components/common/Search/Search";
import archivosRec from "assets/img/archivosRec.svg";
import { formatDate } from "Utils/Fn/DateParser";
import { DynamicRow } from "Interface/generic.model";
import e from "./style.module.css";
import AlertNotification, { IAlert } from "components/common/AlertNotification/AlertNotification";

export const ClaimsList = () => {
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState<IAlert>({ show: false, title: '', details: '', variant: 'Danger' });
  const [allClaims, setAllClaims] = useState<any[]>([]);
  const [Claims, setClaims] = useState<any[]>([]);
  const [filters, setFilters] = useState({
    numeroChasis: '',
    numeroPoliza: '',
    identificacion: '',
    nombreCliente: ''
  });

  const statusColor: any = {
    Abierto: 'bg-info',
    Cerrado: 'bg-secondary'
  }

  const TABLE_ROWS = [
    { label: 'Estado', key: 'estadoReclamacion', slotName: 'statusSlot' },
    { label: 'Chasis', key: 'numeroChasis' },
    { label: 'Nro. Póliza', key: 'numeroPoliza' },
    { label: 'Identificación', key: 'identificacion' },
    { label: 'Nombre del cliente', key: 'nombreCliente' },
    { label: 'Aseguradora', key: 'nombreAseguradora' },
    { label: 'Ramo', key: 'nombreRamo' },
    { label: 'Fecha siniestro', key: '_due_date' },
    { label: 'Fecha apertura', key: '_start_date' }
  ];

  useEffect(() => {
    apiService({
      name: 'getClaimsCop',
      queryParams: { _codigoCliente: JSON.parse(localStorage.getItem('cliCod') || '{}') },
      onSuccess: ({ response }) => {
        const resp = response.map((data: any) => (
          {
            ...data,
            id: data.codPoliza,
            _due_date: formatDate(data.fechaRegistro),
            _start_date: formatDate(data.fechaApertura)
          }
        ));
        setAllClaims(resp);
        setClaims(resp);
      },
      onError: (error) => {
        console.error('Error:', error);
        setAlert({
          show: true,
          title: 'Error al obtener datos',
          details: error,
          variant: 'Danger'
        })
      },
      onFinally() {
        setLoading(false);
      }
    });
  }, []);

  const resetAlert = () => {
    setAlert(prev => ({ ...prev, show: false }));
  };

  const statusSlotTag = (row: DynamicRow) => {
    return (
      <span className={`badge ${statusColor[row.estadoReclamacion]}`}>{row.estadoReclamacion}</span>
    );
  };

  const handleFilterChange = (key: string, value: string) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    applyFilters(newFilters);
  };

  const applyFilters = (filters: any) => {
    const filteredClaims = Claims.filter((claim) => {
      return Object.keys(filters).every((key) => {
        return filters[key] === '' || claim[key].toLowerCase().includes(filters[key].toLowerCase());
      });
    });
    setAllClaims(filteredClaims);
  };

  return (
    <>
      <div className="container pb-3">
        <section className="row">
          <div className="col-md-4 col-lg-3">
            <img
              src={archivosRec}
              alt="Imagen vector de archivo con folder"
              className={e.img_polizas}
            />
          </div>
          <div className="col-md-8 col-lg-9 text-center text-md-start">
            <h3>Reclamaciones</h3>
            <p className="mb-1">Realiza y da seguimientos a tus reclamaciones.</p>
            <div className="d-flex justify-content-center justify-content-md-start">
              <span className="deco_line" />
            </div>
            <div className="row mt-3 mt-md-4 px-3 p-md-1">
              <p className="my-0"><b>Filtrar por:</b></p>
              <div className="row">
                <div className="col-md-3">
                  <Search
                    onChange={(e) => handleFilterChange("numeroChasis", e.target.value)}
                    label="Num. chasis"
                    labelClass={e.labelClass}
                    placeholder="Num. chasis"
                    disabled={loading}
                  />
                </div>
                <div className="col-md-3">
                  <Search
                    onChange={(e) => handleFilterChange("numeroPoliza", e.target.value)}
                    label="Num. póliza"
                    labelClass={e.labelClass}
                    placeholder="Num. póliza"
                    disabled={loading}
                  />
                </div>
                <div className="col-md-3">
                  <Search
                    onChange={(e) => handleFilterChange("identificacion", e.target.value)}
                    label="Identificación"
                    labelClass={e.labelClass}
                    placeholder="Identificación"
                    disabled={loading}
                  />
                </div>
                <div className="col-md-3">
                  <Search
                    onChange={(e) => handleFilterChange("nombreCliente", e.target.value)}
                    label="Nombre del cliente"
                    labelClass={e.labelClass}
                    placeholder="Nombre del cliente"
                    disabled={loading}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className={`pt-4 pb-5 container-fluid ${e.table_ctn}`}>
        <div className="container">
          {loading ? (
            <SkeTable
              col={10}
              row={8}
              className="pt-1"
            />
          ) : (
            <div className={e['table-container']}>
              <TableRender
                id="PolicesListTable"
                schema={TABLE_ROWS}
                rows={allClaims}
                slots={{
                  'statusSlot': statusSlotTag
                }}
              />
            </div>
          )}
        </div>
      </div>
      <AlertNotification
        show={alert?.show}
        title={alert?.title}
        details={alert?.details}
        variant={alert?.variant}
        onClose={resetAlert}
      />
    </>
  );
};
